import { render, staticRenderFns } from "./icon-upload.vue?vue&type=template&id=2ebca323&"
import script from "./icon-upload.vue?vue&type=script&lang=js&"
export * from "./icon-upload.vue?vue&type=script&lang=js&"
import style0 from "./icon-upload.vue?vue&type=style&index=0&id=2ebca323&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports